import type { BriefingGenerationStatus } from "api/briefingApi.slice";
import { UIActionButton } from "common/components";
import * as Styled from "domains/briefing/components/CompletedGenerationActionButtons/CompletedGenerationActionButtons.styled";

type CompletedGenerationActionButtonsProps = {
  status: BriefingGenerationStatus;
  onDownloadButtonPress: () => void;
  onCrossButtonPress: () => void;
};

export const CompletedGenerationActionButtons = ({
  status,
  onDownloadButtonPress,
  onCrossButtonPress,
}: CompletedGenerationActionButtonsProps) => {
  if (status === "Processing") return null;

  return (
    <Styled.CompletedDownloadContainer>
      {status === "Done" && <UIActionButton type="download" onClick={onDownloadButtonPress} hideLabel />}
      <Styled.CloseButton onClick={onCrossButtonPress} />
    </Styled.CompletedDownloadContainer>
  );
};
